import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/illustrations/vpn/secure-connection-icon.svg")